import { AlertModal, Loader, Spinner } from '@/components/Common';
import { SelectDropDown } from '@/components/Common/SelectDropDown/SelectDropDown';
import { Input } from '@/components/ui';
import { CACHE_TIME } from '@/constants';
import { trpc } from '@/data-loaders';
import { useDisciplineList, useHandleError, useHandleSuccess, useSchoolList } from '@/hooks';
import { useAwmsStore } from '@/store';
import { Button } from '@curtin-dxp/curtin-ui';
import { CircleCheckBig, UserX } from 'lucide-react';
import { ChangeEvent, useEffect, useRef, useState } from 'react';
import { DisciplineListing } from './DisciplineListing';

export const Discipline = () => {
  const activeYear = useAwmsStore((state) => state.activeYear);
  const { data: schoolList, isLoading: isSchoolListLoading, error: schoolListError } = useSchoolList(activeYear);
  const [selectedSchool, setSelectedSchool] = useState<number | undefined>(undefined);
  const handleError = useHandleError();
  const [disciplineName, setDisciplineName] = useState<string>('');
  const trpcUtils = trpc.useUtils();
  const sendToastAddDisciplineSuccess = useHandleSuccess({ title: 'Add discipline' });

  const handleInvalidateAndRefetch = async () => {
    trpcUtils.schoolUnit.getDisciplineBySchoolIdList.invalidate();
    trpcUtils.schoolUnit.getDisciplineBySchoolIdList.refetch();
  };

  const { mutate: addDiscipline, isError } = trpc.admin.addDiscipline.useMutation({
    onSuccess: () => {
      handleInvalidateAndRefetch();
      sendToastAddDisciplineSuccess();
    },
    onError: (error) => {
      handleError([error]);
    },
  });

  const handleSchoolChange = (id: number): void => {
    setSelectedSchool(id);
  };

  const handleAddDiscipline = async (): Promise<void> => {
    addDiscipline({ schoolId: selectedSchool!, discipline: disciplineName, year: activeYear });
  };
  useEffect(() => {
    if (schoolList) setSelectedSchool(schoolList[0]?.id);
  }, [schoolList]);

  useEffect(() => {
    if (schoolListError) {
      console.error('Error fetching school list:', { schoolListError });
      handleError([schoolListError]);
    }
  }, [handleError, schoolListError]);
  if (isSchoolListLoading) {
    return <Loader />;
  }

  return (
    <div className="items-left ml-10 mt-10 flex flex-col justify-center gap-10">
      <div>
        <SelectDropDown
          valueChangeCallback={handleSchoolChange}
          initialValue={schoolList == null ? 0 : schoolList[0]?.id}
          list={schoolList}
          className="border-secondary-grey-04 text-b2"
        ></SelectDropDown>
      </div>
      <div className="flex w-[500px] flex-row justify-start gap-10">
        <Input
          type="text"
          value={disciplineName}
          className="w-[250px] border-secondary-grey-04 pr-10 text-b2"
          placeholder="Enter discipline name"
          onChange={(e: ChangeEvent<HTMLInputElement>) => setDisciplineName(e.target.value)}
        />
        <Button
          variant="outline-secondary"
          className="h-10 border-black bg-black text-white hover:bg-transparent hover:text-black focus:outline-none focus-visible:ring-1
            focus-visible:ring-inset focus-visible:ring-white focus-visible:ring-offset-0"
          aria-label="Validate Curtin ID"
          onClick={handleAddDiscipline}
        >
          Add discipline
        </Button>
      </div>

      {selectedSchool && <DisciplineListing selectedSchool={selectedSchool} />}
    </div>
  );
};
